// extracted by mini-css-extract-plugin
export default {"templateDiv":"TemplateExcelView_templateDiv__bEhmB"};